var exports = {
  "oN": "ComposerInline.module__customEmoji___bUJEaW",
  "wh": "ComposerInline.module__plainText___bUJEaW",
  "eu": "ComposerInline.module__literal___bUJEaW",
  "p6": "ComposerInline.module__spoiler___bUJEaW",
  "sM": "ComposerInline.module__srOnly___bUJEaW",
};

module.exports = exports;
